import type { Currency, PromotionLineItem } from '@weft/types';
import { formatNumber } from '@weft/utils';
import { getCurrencySymbol } from 'apps/app/src/services/currency-symbol-mapper';
import { generatePromotionTitle, getCalculationByType, getAmountByType } from 'apps/app/src/services/promotions-formatter';
import React from 'react';
import { getPromotionConfigDefaultValue } from '../../../../hooks/use-promotions-config-default-value';
import { LightInvoiceProductItem } from './LightInvoiceProductItem';
import { LightInvoiceProductSection } from './LightInvoiceProductSection';

type LightInvoicePromotionsProps = {
  promotionLineItems: PromotionLineItem[]
  isPdf?: boolean
  chargedAmount: number
  promotionsAmount: number
  currency: Currency
};

export const LightInvoicePromotions:React.FC<LightInvoicePromotionsProps> = ({
  promotionLineItems,
  isPdf,
  chargedAmount,
  promotionsAmount,
  currency,
}) => {
  return (
    <div className="space-y-5">
      {promotionLineItems.map((lineItem) => {
        const { name, promotionModel, deductedAmount } = lineItem.lineItemPromotion;
        const { promotionType, promotionConfiguration } = promotionModel;
        const amount = getPromotionConfigDefaultValue(promotionConfiguration, promotionType);

        const currencySymbol = getCurrencySymbol(currency);

        return (
          <LightInvoiceProductSection
            key={lineItem.id}
            name={name}
            price={`-${currencySymbol}${formatNumber(deductedAmount)}`}
            isPdf={isPdf}
          >
            <LightInvoiceProductItem
              name={generatePromotionTitle(promotionType, amount)}
              price={getCalculationByType(promotionType, chargedAmount - promotionsAmount + deductedAmount)}
              units={getAmountByType(promotionType, amount)}
              currency={currency}
            />
          </LightInvoiceProductSection>
        );
      })}
    </div>
  );
};